import { SKTBaseComponent } from "../../components/SKTBaseComponent";
import { SKTButton } from "../../components/SKTButton";
import { SKTForm } from "../../components/SKTForm";
import { SKTInfo } from "../../components/SKTInfo";
import { SKTPanel, SKTPanelBody } from "../../components/SKTPanel";
import { SKTPassword } from "../../components/SKTTextField";
import { useState } from "react";
import { useData } from "../../hooks/Data";
import { isValidPassword, passwordsMatch } from "../../utils/validators";
import { SKTToggle } from "../../components/SKTToggle";
import { apiPOST } from "../../hooks/APIHook";
import { API_ENDPOINTS } from "../../config";
import qs from "qs";
import { getFromQueryString } from "../../utils/queryString";
import { SKTAction } from "../../components/SKTAction";

export const ChangePasswordForm = ({ doLogout }) => {
  const data = useData({
    validators: {
      iPassword: isValidPassword,
      iPassword2: passwordsMatch,
    },
    defaults: {
      secret: getFromQueryString("t"),
    },
  });
  const [state, setState] = useState("change");

  const onClick = () => {
    apiPOST(
      API_ENDPOINTS.profile.changePassword,
      qs.stringify(data.values)
    ).then((result) => {
      const status = result.data.status;
      if (status === "ok") {
        setState("changed");
        doLogout("Salasanasi on nyt vaihdettu! Kirjaudu uudestaan sisään");
      }
      if (status === "fail") setState("error");
      if (status === "error") setState("error");
    });
  };

  return (
    <SKTPanel>
      <SKTPanelBody>
        <SKTForm>
          <SKTInfo>
            <SKTToggle when={state === "change"}>
              <p>
                Tästä pääset vaihtamaan salasanasi. Uuden salasanan tulee olla
                vähintään 8 merkkiä pitkä, ja siinä pitää olla vähintään yksi
                kirjain ja yksi numero.
              </p>
            </SKTToggle>
            <SKTToggle when={state === "changed"}>
              <p>Salasanasi on nyt vaihdettu!</p>
            </SKTToggle>
            <SKTToggle when={state === "error"}>
              <p>
                Salasanan vaihtaminen ei onnistunut, ota yhteys
                asiakaspalveluun!
              </p>
            </SKTToggle>
          </SKTInfo>
          <SKTPassword data={data} id="iPassword" label="Salasana" />
          <SKTPassword data={data} id="iPassword2" label="Salasana uudestaan" />
          <SKTAction
            actionLabel="Vaihda salasana"
            onClick={onClick}
            active={true}
            type="btn-success"
          ></SKTAction>
        </SKTForm>
      </SKTPanelBody>
    </SKTPanel>
  );
};
